import { Redirect, useLocalSearchParams } from 'expo-router';

const ChatPageV2 = () => {
    const params = useLocalSearchParams();
    return <Redirect href={{ pathname: '/sign-up/get-started', params }} />;
};

export default ChatPageV2;
